import { NewsItem, NewsResponse, NewsViewParam } from '../models/users/ChatNews';
import { BaseService } from './BaseService';

export class NewsService extends BaseService {
  /**
   * [뉴스] - IT 트렌드 뉴스 조회.
   */
  public getNews = async (date?: string): Promise<NewsResponse> => {
    const path = date ? `api/user/news?date=${encodeURIComponent(date)}` : `api/user/news`;

    const raw = await this.getResponseAsync<NewsResponse | NewsItem[]>({
      commandPath: path,
      method: 'GET',
    });

    const rawList: NewsItem[] = Array.isArray(raw) ? raw : raw?.news ?? [];

    const news: NewsItem[] = rawList.map((item) => ({
      ...item,
      summaryParagraphs: this.parseParagraphs(item.summaryParagraphs),
      ktdsInsight: this.parseInsight(item.ktdsInsight),
    }));

    const reportId = Array.isArray(raw) ? '' : raw?.reportId ?? '';
    const reportDate = Array.isArray(raw)
      ? rawList[0]?.reportDate ?? ''
      : raw?.reportDate ?? rawList[0]?.reportDate ?? '';

    return { reportId, reportDate, news };
  };

  /**
   * [뉴스] - 기사 상세 열람 기록.
   */
  public postNewsView = async (param: NewsViewParam): Promise<void> => {
    await this.getResponseAsync<unknown>({
      commandPath: `api/user/news/view`,
      method: 'POST',
      body: param,
    });
  };

  /** summaryParagraphs가 JSON 문자열로 올 수 있어 배열로 정규화한다. */
  private readonly parseParagraphs = (value: unknown): string[] => {
    if (Array.isArray(value)) return value as string[];
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed.startsWith('[')) {
        try {
          const parsed = JSON.parse(trimmed) as unknown;
          if (Array.isArray(parsed)) return parsed as string[];
        } catch {
          // 파싱 실패 시
        }
      }
      return trimmed ? [trimmed] : [];
    }
    return [];
  };

  /** ktdsInsight도 JSON 문자열로 저장되어 있어 객체로 정규화한다. */
  private readonly parseInsight = (value: unknown): NewsItem['ktdsInsight'] => {
    if (value && typeof value === 'object') return value as NewsItem['ktdsInsight'];
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return null;
      try {
        const parsed = JSON.parse(trimmed) as unknown;
        if (parsed && typeof parsed === 'object') return parsed as NewsItem['ktdsInsight'];
      } catch {
        // 파싱 실패 시
      }
    }
    return null;
  };
}
